<div class="gather-header">
  <div class="header-container">
    <div class="header-logos">
      <div id="aq-logo" class="logo">
        <svg-icon src="../../../assets/images/logos/Aquent_Skill_Lockup_Black.svg"></svg-icon>
      </div>
    </div>
    <h2 *ngIf="headerText" id="header-text" class="header-text">
      {{headerText}}
    </h2>
  </div>
</div>
